import isFunction from 'lodash/isFunction'

export const guards = ({ router, config }) => {
  async function setPageTitleFromMeta ({ meta }, from, next) {
    const params = { router, config }
    const title = isFunction(meta.title) ? await meta.title(params) : meta.title
    document.querySelector('title').innerText = title || config.get('project.name')
    document.title = title || config.get('project.name')
    next()
  }

  function legacyRouterMode ({ fullPath }, from, next) {
    if (fullPath.substr(0, 2) === '/#') {
      const path = fullPath.substr(2)
      next(path)
      return
    }
    next()
  }

  router.beforeEach(legacyRouterMode)
  router.beforeEach(setPageTitleFromMeta)
  return router
}

export default guards
